module.exports = __webpack_public_path__ + "static/media/Library.4ded4adc.md";